export default __webpack_public_path__ + "static/media/lowpoly_tree.f224c16d.gltf";